<div class="progress-loader" [hidden]="!loading">
  <mat-progress-spinner [mode]="'indeterminate'">
  </mat-progress-spinner>
</div>
